// Pasar a 1080p desde el lienzo — ADR-2026-09-27-borrador-480p-y-pasar-a-1080p.
// Guard de saldo antes de abrir (como Mejorar), la confirmación con el costo, y la
// generación entra por `onGeneracion` como Animar: el lienzo cuelga la celda "Generando…"
// debajo del borrador y la convierte en el 1080p cuando llega (con `executionIds`, se
// retoma tras una recarga).
import { useEffect, useState } from 'react';
import { PasarA1080pDialogo } from '../../../components/PasarA1080pDialogo';
import { borradorDe, creditosDePasarA1080p } from '../../../lib/resolucionVideo';
import { pasarBorradorA1080pComoTanda } from '../../../lib/videoBorrador';
import { estimarDuracionVideoMs } from '../../../utils/estimacionVideo';
import type { PropsDeHerramienta } from './herramienta';
import { consultarSaldo, tipoDeLimite } from './saldo';

export const PanelPasarA1080p: React.FC<PropsDeHerramienta> = ({ celda, ratio, onCerrar, onGeneracion, onLimite }) => {
  const borrador = borradorDe(celda.datos.datosGeneracion);
  const segundos = borrador?.segundos ?? 5;
  const creditos = creditosDePasarA1080p(segundos);
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    let vivo = true;
    void consultarSaldo(celda.companyId).then((s) => {
      if (!vivo) return;
      if (s.restantes !== null && s.restantes < creditos) {
        onLimite(tipoDeLimite(s.plan));
        onCerrar();
        return;
      }
      setAbierto(true);
    });
    return () => {
      vivo = false;
    };
  }, [celda.companyId, creditos, onCerrar, onLimite]);

  const confirmar = () => {
    const executionId = crypto.randomUUID();
    onGeneracion({
      tipo: 'pasar-a-1080p',
      total: 1,
      creditos,
      ratio,
      producto: celda.titulo,
      esVideo: true,
      origenId: celda.imageId,
      executionIds: [executionId],
      duracionEstimadaMs: estimarDuracionVideoMs({ quality: 'profesional', resolution: '1080p', durationSeconds: segundos }),
      resultado: pasarBorradorA1080pComoTanda({ videoId: celda.imageId, executionId }),
    });
    onCerrar();
  };

  return (
    <PasarA1080pDialogo
      abierto={abierto}
      creditos={creditos}
      segundos={segundos}
      procesando={false}
      onCerrar={onCerrar}
      onConfirmar={confirmar}
    />
  );
};
